export class WorkActivityOptionsModel {
    aoId: string;
    aoCode: string;
    aoShortName: string;
    aoLongName: string;
    aoInactive: boolean;;
    aoCreatedDate : Date;
    aoCreatedBy: string;
    aoLastModifiedDate : Date;
    aoLastModifiedBy: string;
  }